/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * constants.js
 * -------------------------------------------
 * Central place to manage all static values,
 * reusable strings, URLs, route names, and other
 * configuration constants used across the app.
 */

export const POWERED_BY_TEXT = 'Powered by'
export const APP_NAME = 'arcee'
export const ORGANIZATION_NAME = 'Rudra Coresoft'

/**
 * Auto-managed system columns the backend creates and maintains. They are not
 * user-defined schema, so they must be excluded from the table schema editor
 * (and any create/edit field list). Single source of truth — add new system
 * fields here, not in each form. deleted_at is opt-in (only present when
 * soft_delete is enabled) but is still system-managed when it exists.
 */
export const AUTO_MANAGED_FIELDS = [
  'id',
  'created_by_id',
  'created_at',
  'updated_at',
  'deleted_at',
];